/**
 * Témoin « déjà connecté » lu par la vitrine publique.
 *
 * La vitrine et l'application vivent sur deux origines : la vitrine ne peut donc
 * pas lire la session. L'application pose ce témoin sur le domaine parent pour
 * que l'accueil public conduise directement une personne connectée à son espace.
 * Sa valeur est constante : ni jeton, ni identifiant, ni donnée personnelle. Il
 * n'accorde aucun accès — l'application revérifie toujours la session.
 */
export const SITE_HINT_COOKIE = 'myequip_app';

/** Durée alignée sur une session web inactive ; rafraîchie à chaque ouverture. */
const MAX_AGE_SECONDS = 30 * 24 * 3600;

/**
 * Chaîne à écrire dans `document.cookie`, ou `undefined` hors navigateur web.
 * `app.exemple.fr` partage le témoin avec `exemple.fr` ; tout autre hôte (démo
 * locale, adresse IP) le garde pour lui seul — sur `localhost` il reste lisible
 * par la vitrine, les ports ne cloisonnant pas les cookies.
 */
export function siteHintCookie(
  location: { protocol: string; hostname: string },
  active: boolean,
): string | undefined {
  if (location.protocol !== 'https:' && location.protocol !== 'http:') return undefined;
  const domain = location.hostname.startsWith('app.')
    ? `; domain=${location.hostname.slice('app'.length)}`
    : '';
  const secure = location.protocol === 'https:' ? '; secure' : '';
  return `${SITE_HINT_COOKIE}=1; path=/${domain}; max-age=${active ? MAX_AGE_SECONDS : 0}; samesite=lax${secure}`;
}
